<script setup lang="ts">
import { DBLocalTheme } from "@/enumLocal/theme";
import { i18nGlobal } from "@/i18n";

import { ERROR_MESSAGE_DELAY, useStoreError } from "@/stores/storeError";
import { useStoreUser } from "@/stores/storeUser";
import { isEmptyCheckLocal } from "@/utils/utils";
import { DBRetCode } from "@functions/models/DBEnum";
import { useTheme } from "vuetify";

/*
  costants
*/
const vuetifyTheme = useTheme();
const { t: $t } = i18nGlobal;
/*
  storeAuth
*/

const errorStore = useStoreError();
const userStore = useStoreUser();
const iconType = ref("mdi-alert-circle-outline");

const snackbar = ref(false);
const color = ref(vuetifyTheme.current.value.colors.warning);
watch(
  errorStore,
  async (errorStore) => {
    if (errorStore.$state.message) {
      snackbar.value = true;
      color.value = setColor(errorStore.$state.type);
    }
  },
  { immediate: true }
);

watch(
  userStore,
  async (userStore) => {
    if (userStore?.userData && userStore?.loaded) {
      const themeToUse = !isEmptyCheckLocal(userStore?.userData?.theme)
        ? (userStore?.userData?.theme as string)
        : DBLocalTheme.BLUE_THEME;
      vuetifyTheme.change(themeToUse);
    }
  },
  { immediate: true }
);

function setColor(et: DBRetCode) {
  switch (et) {
    case DBRetCode.ERROR:
      iconType.value = "mdi-alert-circle-outline";
      //return 'vuetifyTheme.current.value.colors.error'
      return "error";
      break;
    case DBRetCode.WARNING:
      iconType.value = "mdi-alert-outline";
      //return vuetifyTheme.current.value.colors.WARNING
      return "warning";
      break;
    case DBRetCode.INFO:
      iconType.value = "mdi-alert-circle-outline";
      //return vuetifyTheme.current.value.colors.info
      return "info";
      break;
    case DBRetCode.SUCCESS:
      iconType.value = "mdi-checkbox-marked-circle-outline";
      //return vuetifyTheme?.current?.value?.colors?.success ?? 'green'
      return "success";
      break;
    default:
      iconType.value = "mdi-alert-circle-outline";
      return vuetifyTheme.current.value.colors.error;
      break;
  }
}
</script>
<template>
  <v-snackbar
    v-if="errorStore.$state.message"
    v-model="snackbar"
    vertical
    location="top end"
    :color="color"
    :timeout="ERROR_MESSAGE_DELAY"
    rounded="lg"
  >
    <template #text>
      <div class="d-flex align-start">
        <div class="d-flex align-start">
          <v-icon class="text-24">{{ iconType }}</v-icon>
        </div>
        <div>
          <strong class="text-sm mt-2"> {{ errorStore.$state.message }}</strong>
        </div>
      </div>

      <h6 class="d-inline-block text-subtitle-2 mb-1 mt-2">
        <div v-html="errorStore.techInfo" class="wrap-text"></div>
      </h6>
    </template>
    <template v-slot:actions>
      <v-btn color="primary" variant="elevated" @click="snackbar = false">
        {{ $t("button.close") }}
      </v-btn>
    </template>
  </v-snackbar>
</template>
